import { connect } from 'react-redux'
import { getHome } from '../selectors'
import Home from '../components/home'

const mapStateToProps = state => ({
  home: getHome(state),
})

export default connect(
  mapStateToProps,
  null,
)(Home)



// WEBPACK FOOTER //
// ./src/modules/core/containers/home.js